import { useState } from 'react';

import { Stack, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { atom, useAtom, useAtomValue } from 'jotai';
import { loadable } from 'jotai/utils';
import { useTranslation } from 'react-i18next';

import { LanguageEnum } from '~enums';
import AccessCommandForm from '~features/devices/forms/skcDeviceCommandForm/skcDeviceCommandForm';
import { OrganisationsService, PartnerAutocomplete } from '~features/organisations';
import useOrganisationFilter from '~features/organisations/hooks/useOrganisationFilter';
import { useFormContainerState } from '~hooks';

const service = new OrganisationsService();

const bla = ['henk', 'annie', 'bert'];

const oriAtom = atom();
const loadableOriAtom = loadable(oriAtom);

/**
 * This page is meant as a sandbox for a develop to develop or
 * test a component outside of the normal flow
 */
const SandboxPage = () => {
	const { t } = useTranslation();

	const bla = useFormContainerState();

	const [loading, setLoading] = useState(false);
	const [dateVal, setDateVal] = useState<Dayjs | null>(dayjs());
	const [val, setVal] = useState(null);
	const [textVal, setTextVal] = useState<string | null>(null);

	const [numVal, setNumVal] = useState(0);
	const [boolVal, setBoolVal] = useState(false);

	const [orignalImageUri, setOriginalImageUri] = useState<string | null>(null);

	const [lng, setLng] = useState<LanguageEnum>(LanguageEnum.English);

	const [oriValue, setOriValue] = useAtom(oriAtom);

	const [organisation, setOrganisation] = useOrganisationFilter('globalState');

	return (
		<Stack spacing={1}>
			<Typography variant='body3'>Joe</Typography>
			<PartnerAutocomplete />
			<AccessCommandForm />
			Sandbox
		</Stack>
	);
};

export default SandboxPage;
